import InterviewInviteActionEntry from './InterviewInviteActionEntry';

export default InterviewInviteActionEntry;
